import { hasElementPanel } from './elementDefinitionUtils';

export function shouldOpenElementDialog(elementType) {
  return hasElementPanel(elementType);
}
